import { render, staticRenderFns } from "./rolldetail.vue?vue&type=template&id=30377752&"
import script from "./rolldetail.vue?vue&type=script&lang=js&"
export * from "./rolldetail.vue?vue&type=script&lang=js&"
import style0 from "./rolldetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports